<template>
    <div class="t_wrapper">
        <div class="t_filter">
            <div class="t_filter_box_wrapper ">
                <div class="t_filter_box_wrapper_bg"></div>
                <div class="t_filter_box t_filter_box_inner">
                    <div class="t_filter_item t_filter_search" v-if="filterKey === 'search'" v-for="(filter, filterKey) in filters">
                        <div class="t_filter_pack">
                            <div class="filter_search">
                                <input type="text" v-model="request.search" placeholder="Пошук" v-on:keyup.enter="applyFilters">
                            </div>
                            <a @click.prevent="applyFilters" class="t_filter_button-round">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="t_filter_button-round_v" d="M17.2583 16.075L14.425 13.25C15.3392 12.0854 15.8352 10.6472 15.8333 9.16667C15.8333 7.84813 15.4423 6.5592 14.7098 5.46287C13.9773 4.36654 12.9361 3.51206 11.7179 3.00747C10.4997 2.50289 9.15927 2.37087 7.86607 2.6281C6.57286 2.88534 5.38497 3.52027 4.45262 4.45262C3.52027 5.38497 2.88534 6.57286 2.6281 7.86607C2.37087 9.15927 2.50289 10.4997 3.00747 11.7179C3.51206 12.9361 4.36654 13.9773 5.46287 14.7098C6.5592 15.4423 7.84813 15.8333 9.16667 15.8333C10.6472 15.8352 12.0854 15.3392 13.25 14.425L16.075 17.2583C16.1525 17.3364 16.2446 17.3984 16.3462 17.4407C16.4477 17.4831 16.5567 17.5048 16.6667 17.5048C16.7767 17.5048 16.8856 17.4831 16.9872 17.4407C17.0887 17.3984 17.1809 17.3364 17.2583 17.2583C17.3364 17.1809 17.3984 17.0887 17.4407 16.9872C17.4831 16.8856 17.5048 16.7767 17.5048 16.6667C17.5048 16.5567 17.4831 16.4477 17.4407 16.3462C17.3984 16.2446 17.3364 16.1525 17.2583 16.075ZM4.16667 9.16667C4.16667 8.17776 4.45991 7.21106 5.00932 6.38882C5.55873 5.56657 6.33962 4.92571 7.25325 4.54727C8.16688 4.16883 9.17222 4.06982 10.1421 4.26274C11.112 4.45567 12.0029 4.93187 12.7022 5.63114C13.4015 6.3304 13.8777 7.22131 14.0706 8.19122C14.2635 9.16112 14.1645 10.1665 13.7861 11.0801C13.4076 11.9937 12.7668 12.7746 11.9445 13.324C11.1223 13.8734 10.1556 14.1667 9.16667 14.1667C7.84059 14.1667 6.56882 13.6399 5.63114 12.7022C4.69345 11.7645 4.16667 10.4928 4.16667 9.16667Z" fill="#B2B3BC"></path></svg>
                            </a>
                        </div>

                        <a :class="{'t_filter_switcher': true, 'active': filtersEnabled}" @click.prevent="filtersEnabled = ! filtersEnabled">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect x="4" y="7" width="16" height="2" rx="1" fill="#B2B3BC"/>
                                <rect x="4" y="15" width="16" height="2" rx="1" fill="#B2B3BC"/>
                                <rect x="7" y="14" width="4" height="4" rx="2" fill="#EDF3ED" stroke="#B2B3BC" stroke-width="2"/>
                                <rect x="13" y="6" width="4" height="4" rx="2" fill="#EDF3ED" stroke="#B2B3BC" stroke-width="2"/>
                            </svg>
                            <svg class="active-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect x="4" y="7" width="16" height="2" rx="1" fill="white"/>
                                <rect x="4" y="15" width="16" height="2" rx="1" fill="white"/>
                                <rect x="7" y="14" width="4" height="4" rx="2" fill="#0096E0" stroke="white" stroke-width="2"/>
                                <rect x="13" y="6" width="4" height="4" rx="2" fill="#0096E0" stroke="white" stroke-width="2"/>
                            </svg>
                        </a>
                    </div>
                    <div class="t_filter_others" v-if="showFilters">
                        <div class="t_filter_item" v-if="filterKey !== 'search'" v-for="(filter, filterKey) in filters">
                            <UsersSelectComponent v-if="filterKey === 'manager'" :is-filter="true" :label="false" v-model="request[filterKey]" :region-id="request.region_id || null" :placeholder="filter.name" :managers="true" />
                            <CompanySelectComponent v-else-if="filterKey === 'company_id'" :is-filter="true" :label="false" v-model="request[filterKey]" :region-id="request.region_id || null" :placeholder="filter.name" :managers="true" :company-only-owner="companyOnlyOwner"/>
                            <SelectComponent v-else v-model="request[filterKey]" :name="filter.name" :values="filter.values" />
                        </div>
                        <div class="t_filter_item">
                            <button type="button" class="t_filter_item_button form_item_button form_item_button-blue" @click="applyFilters">Застосувати</button>
                            <a class="t_filter_item_button t_filter_item_button-mobile form_item_button form_item_button-trans" @click="clearFilters">Всі</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="t_filter_box-mobile">
                <div class="t_filter_pack">
                    <div class="filter_search">
                        <input type="text" v-model="request.search" placeholder="Пошук">
                    </div>
                    <a @click.prevent="applyFilters" class="t_filter_button-round">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="t_filter_button-round_v" d="M17.2583 16.075L14.425 13.25C15.3392 12.0854 15.8352 10.6472 15.8333 9.16667C15.8333 7.84813 15.4423 6.5592 14.7098 5.46287C13.9773 4.36654 12.9361 3.51206 11.7179 3.00747C10.4997 2.50289 9.15927 2.37087 7.86607 2.6281C6.57286 2.88534 5.38497 3.52027 4.45262 4.45262C3.52027 5.38497 2.88534 6.57286 2.6281 7.86607C2.37087 9.15927 2.50289 10.4997 3.00747 11.7179C3.51206 12.9361 4.36654 13.9773 5.46287 14.7098C6.5592 15.4423 7.84813 15.8333 9.16667 15.8333C10.6472 15.8352 12.0854 15.3392 13.25 14.425L16.075 17.2583C16.1525 17.3364 16.2446 17.3984 16.3462 17.4407C16.4477 17.4831 16.5567 17.5048 16.6667 17.5048C16.7767 17.5048 16.8856 17.4831 16.9872 17.4407C17.0887 17.3984 17.1809 17.3364 17.2583 17.2583C17.3364 17.1809 17.3984 17.0887 17.4407 16.9872C17.4831 16.8856 17.5048 16.7767 17.5048 16.6667C17.5048 16.5567 17.4831 16.4477 17.4407 16.3462C17.3984 16.2446 17.3364 16.1525 17.2583 16.075ZM4.16667 9.16667C4.16667 8.17776 4.45991 7.21106 5.00932 6.38882C5.55873 5.56657 6.33962 4.92571 7.25325 4.54727C8.16688 4.16883 9.17222 4.06982 10.1421 4.26274C11.112 4.45567 12.0029 4.93187 12.7022 5.63114C13.4015 6.3304 13.8777 7.22131 14.0706 8.19122C14.2635 9.16112 14.1645 10.1665 13.7861 11.0801C13.4076 11.9937 12.7668 12.7746 11.9445 13.324C11.1223 13.8734 10.1556 14.1667 9.16667 14.1667C7.84059 14.1667 6.56882 13.6399 5.63114 12.7022C4.69345 11.7645 4.16667 10.4928 4.16667 9.16667Z" fill="#B2B3BC"></path></svg>
                    </a>
                </div>
                <a class="t_filter_switcher">
                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="24" fill="white" stroke="#E2E3E4" stroke-width="2"></circle><rect x="12.5" y="14.0625" width="25" height="3.125" rx="1.5625" fill="#2C2A44"></rect><rect x="12.5" y="23.4375" width="25" height="3.125" rx="1.5625" fill="#2C2A44"></rect><rect x="12.5" y="32.8125" width="25" height="3.125" rx="1.5625" fill="#2C2A44"></rect><mask id="path-5-inside-1" fill="white"><rect x="28.125" y="12.5" width="6.25" height="6.25" rx="2"></rect></mask><rect x="28.125" y="12.5" width="6.25" height="6.25" rx="2" fill="white" stroke="#2C2A44" stroke-width="5" mask="url(#path-5-inside-1)"></rect><mask id="path-6-inside-2" fill="white"><rect x="26.5625" y="31.25" width="6.25" height="6.25" rx="2"></rect></mask><rect x="26.5625" y="31.25" width="6.25" height="6.25" rx="2" fill="white" stroke="#2C2A44" stroke-width="5" mask="url(#path-6-inside-2)"></rect><mask id="path-7-inside-3" fill="white"><rect x="17.1875" y="21.875" width="6.25" height="6.25" rx="2"></rect></mask><rect x="17.1875" y="21.875" width="6.25" height="6.25" rx="2" fill="white" stroke="#2C2A44" stroke-width="5" mask="url(#path-7-inside-3)"></rect></svg>
                </a>
            </div>
        </div>
        <div class="t_main">
            <div class="t_container" tabindex="1">
                <div class="t_head">
                    <div :class="{'t_head_container': true, 't_head_container-shift': hasGroup}">
                        <div class="t_row t_row-header" style="transform: translateX(0px);">
                            <div v-for="(column, columnKey) in header" class="t_cell t_cell-header" :style="column.style">
                                <span v-if="! ['selectCheckbox', 'openDetails', 'attachments', 'openWeatherReport', 'downloadReport', 'downloadReportConfirmed', 'open'].includes(columnKey)" class="t_cell-header_text" v-text="column.name"></span>

                                <select-all-checkbox-component v-if="columnKey === 'selectCheckbox' && (part === 'applications' || part === 'orders')"
                                                           :value="!isSelectAll"
                                                           @setAll="setAll"
                                />
                                <span v-if="column.sort" class="t_cell-header_switcher">
                                    <a href="javascript:;" @click="changeOrder(columnKey)">
                                    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.34535 0.566946C5.72112 0.241518 6.27888 0.241519 6.65465 0.566947L9.16858 2.74407C9.86848 3.3502 9.43981 4.5 8.51393 4.5H3.48607C2.56019 4.5 2.13152 3.35021 2.83142 2.74407L5.34535 0.566946Z" fill="#E3E3E4"/>
                                        <path d="M5.34535 10.4331C5.72112 10.7585 6.27888 10.7585 6.65465 10.4331L9.16858 8.25593C9.86848 7.6498 9.43981 6.5 8.51393 6.5H3.48607C2.56019 6.5 2.13152 7.64979 2.83142 8.25593L5.34535 10.4331Z" fill="#E3E3E4"/>
                                    </svg>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="t_body" v-if="loading">
                    <div class="t_row" :key="index" v-for="index in request.perPage">
                        <div class="t_cell" v-for="column in (header)" :style="column.style">
                            <div class="t_cell_content">
                                <span class="skeleton"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="t_body" v-if="! loading">
                    <div class="t_row" v-if="data.length === 0">
                        <div class="t-cell text-center" style="width: 100%">
                            <span class="t-no-data">No data</span>
                        </div>
                    </div>
                    <div :class="{'t_row': ! hasGroup}" v-for="(row, index) in data">
                        <GroupComponent v-if="row.isGroup && row.isGroup === true"
                                        @toggle="toggleSelect"
                                        @deleteItem="deleteItem"
                                        :group="row" :key="`group-${index}`" :group-key="index" :is-current-season-selected="isCurrentSeasonSelected"/>
                        <RowComponent v-else v-for="(column, columnKey) in row"
                                      @toggle="toggleSelect"
                                      @deleteItem="deleteItem"
                                      :checked="isSelectAll"
                                      :key="`table-row-${columnKey}-${column.value}`"
                                      :column="column" :column-key="columnKey"
                                      :show-delete="showDelete(row)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="pgs" tabindex="1">
            <div class="pgs_t" v-text="request.perPage"></div>
            <div class="pgs_list">
                <div class="pgs_list_item" @click="changePerPage(50)">50</div>
                <div class="pgs_list_item" @click="changePerPage(100)">100</div>
                <div class="pgs_list_item" @click="changePerPage(500)">500</div>
            </div>
        </div>

        <div class="pagination">
            <a v-if="pagination.currentPage > 1" class="pagination_arrow pagination_arrow-left" @click.prevent="resetPage">
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 1L2 9L10 17" stroke="#2C2A44" strokeWidth="2"/>
                </svg>
            </a>

            <a v-if="pagination.currentPage > 2" class="pagination_number" @click.prevent="gotoPage(pagination.currentPage - 2)" v-text="pagination.currentPage - 2"></a>
            <a v-if="pagination.currentPage > 1" class="pagination_number" @click.prevent="gotoPage(pagination.currentPage - 1)" v-text="pagination.currentPage - 1"></a>

            <a class="pagination_number active" v-text="pagination.currentPage ? pagination.currentPage : 1"></a>

            <a v-if="pagination.lastPage - pagination.currentPage > 0" class="pagination_number" @click.prevent="gotoPage(pagination.currentPage + 1)" v-text="pagination.currentPage + 1"></a>
            <a v-if="pagination.lastPage - pagination.currentPage > 1" class="pagination_number" @click.prevent="gotoPage(pagination.currentPage + 2)" v-text="pagination.currentPage + 2"></a>

            <a class="pagination_arrow pagination_arrow-right" @click.prevent="gotoPage(pagination.lastPage)">
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L9 9L1 17" stroke="#2C2A44" strokeWidth="2"/>
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
import SelectComponent from "./filters/SelectComponent";
import RowComponent from "./RowComponent";
import GroupComponent from "./GroupComponent";
import UsersSelectComponent from "../UsersSelectComponent";
import CompanySelectComponent from "../CompanySelectComponent";
import SelectCheckboxComponent from "./SelectCheckboxComponent";
import SelectAllCheckboxComponent from "./SelectAllCheckboxComponent";

export default  {
    name: "ListComponent",

    components: {CompanySelectComponent, UsersSelectComponent, GroupComponent, RowComponent, SelectComponent,
        SelectCheckboxComponent,
        SelectAllCheckboxComponent
    },

    props: ['url', 'initFilters', 'header', 'season', 'companyOnlyOwner', 'part', 'canDelete', 'deleteOptions'],

    data: function () {
        return {
            loading: true,

            filtersEnabled: false,

            request: {
                perPage: 50,
                page: 1,
                orderBy: null,
                direction: 'desc'
            },

            data: {},
            filters: {},
            pagination: {},

            selectedSeason: 2022,
            currentSeason: 2022,

            selectAll: false,
        };
    },



    mounted() {

        //TODO: refactor
        if(this.isJson(this.season)) {
            this.selectedSeason = JSON.parse(this.season)['selectedSeason'];
            this.currentSeason = JSON.parse(this.season)['currentSeason'];
        } else {
            this.selectedSeason = this.season;
            this.currentSeason = this.season;
        }

        this.filters = this.initFilters;

        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = {};

        let customField = ['search', 'manager', 'company_id', 'orderBy', 'direction'];
        for (const [key, value] of urlSearchParams.entries()) {
            if(value !== 'null') {
                params[key] = value;
            }

            if(!customField.includes(key)) {
                let values = value.split(',');
                for(let index in values) {
                    if(!isNaN(values[index])) {
                        values[index] = parseInt(values[index]);
                    }
                }
                params[key] = values;
            }
        }

        this.request = Object.assign(this.request, params);

        if(this.selectedSeason) {
            this.request.season = this.selectedSeason;
        }

        this.callData();

        Livewire.on('refreshList', this.callData);
        Livewire.on('turnOffSelector', (id) => {
            this.toggleSelect(id, false);
        });
    },

    computed: {
        hasGroup: function () {
            if(! this.data.length) {
                return false;
            }

            return this.data[0].isGroup === true;
        },

        showFilters: function () {
            if(window.innerWidth <= 1100) {
                return true;
            }

            return this.filtersEnabled;
        },

        isCurrentSeasonSelected: function () {
            return this.currentSeason === this.selectedSeason;
        },

        isSelectAll: function () {

            // console.log(this.selectAll)
            return this.selectAll
        }
    },

    methods: {
        showDelete(row) {
            if (this.deleteOptions) {
                let values = [this.canDelete];

                Object.keys(this.deleteOptions).forEach(key => {
                    values.push( this.deleteOptions[key].includes(row[key].raw?.key) );
                });

                return values.every(Boolean);
            }

            return this.isCurrentSeasonSelected;
        },
         isJson(item) {
            item = typeof item !== "string"
                ? JSON.stringify(item)
                : item;

            try {
                item = JSON.parse(item);
            } catch (e) {
                return false;
            }

            if (typeof item === "object" && item !== null) {
                return true;
            }

            return false;
        },

        callData() {
            this.loading = true;

            Livewire.emit('toggleOfSelectors');

            axios.post(this.url, this.request)
                .then((response) => {
                    if(response.data.status !== 'success') {
                        console.error(response, response.data);

                        this.$eventBus.$emit('alert', 'error', 'Під час завантаження списку виникла помилка.');

                        this.loading = false;

                        this.data = [];

                        return;
                    }

                    // this.header = response.data.data.header;
                    this.data = response.data.data.data;
                    this.filters = response.data.data.filters;
                    this.pagination = response.data.data.pagination;

                    this.updateCurrentUrl();

                    this.loading = false;
                }).catch(error => {
                    console.error(error);

                    this.$eventBus.$emit('alert', 'error', 'Під час завантаження списку виникла помилка.');

                    this.loading = false;

                    this.data = [];
                });
        },

        updateCurrentUrl() {
            let url = location.origin + location.pathname;

            for (const [key, value] of Object.entries(this.request)) {
                if(key === 'perPage' && value === 50) {
                    continue;
                }

                if(key === 'page' && value === 1) {
                    continue;
                }

                if(key === 'season') {
                    continue;
                }

                url = this.updateQueryStringParameter(url, key, value);
            }

            history.pushState(null, '', url);
        },

        updateQueryStringParameter(uri, key, value) {
            let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            let separator = uri.indexOf('?') !== -1 ? "&" : "?";

            if (uri.match(re)) {
                return uri.replace(re, '$1' + key + "=" + value + '$2');
            }
            else {
                return uri + separator + key + "=" + value;
            }
        },

        applyFilters() {
            this.callData();
            this.gotoPage(1);
        },

        clearFilters() {
            this.request = {
                perPage: 50,
                page: 1,
            };

            if(this.selectedSeason) {
                this.request.season = this.selectedSeason;
            }

            this.callData();
        },

        toggleSelect(id, status) {
            Livewire.emit('selectToggle-application', id, status);
            Livewire.emit('selectToggle-document', id, status);
            Livewire.emit('selectToggle-field', id, status);
        },

        changeOrder(column) {
            this.request.orderBy = column;
            this.request.direction = (this.request.direction == 'asc')?'desc':'asc';

            this.callData();
        },

        changePerPage(perPage) {
            this.request.perPage = perPage;

            this.callData();
        },

        resetPage() {
            this.gotoPage(1);
        },

        gotoPage(page) {
            this.request.page = page;

            this.callData();
        },

        setAll(status=null) {
            this.selectAll = status;
        },

        toggle(event, status = null) {

            if(status !== null) {
                this.selectAll = status;
            } else {
                this.selectAll = event.target.checked
            }
        },


        deleteItem(id) {
            if (confirm('Ви впевнені?')) {

                this.loading = true;
                let url = new URL(location.href).origin + '/' + this.part;

                axios.delete(url, {data: {id: id}})
                    .then((response) => {
                        if (response.data.status !== 'success') {
                            this.$eventBus.$emit('alert', 'error', 'Під час видалення запису виникла помилка.');
                            this.loading = false;
                            return;
                        }

                        this.callData();

                        this.loading = false;
                    }).catch(error => {
                    console.error(error);

                    this.$eventBus.$emit('alert', 'error', 'Під час видалення запису виникла помилка.');
                    this.loading = false;
                });
            }
        }
    },
}
</script>
